<template>
  <div v-resize="onResize">
    <video-player
      ref="videoPlayer"
      class="vjs-custom-skin"
      :options="playerOptions"
      @playing="onPlayng"
      @waiting="parou"
      @pause="paused"
      @ended="paused"
      @canplay="teste"
      @ready="playerReadied"
    />
  </div>
</template>

<script>
// videojs
import videojs from 'video.js'
window.videojs = videojs
// hls plugin for videojs6
// require('videojs-contrib-hls/dist/videojs-contrib-hls.js')
// export
export default {
  name: 'Iptv',
  props: {
    iptvVolume: Number,
    intervaloMudo: Number,
    link: String
  },
  data () {
    return {
      hls: '',
      volume: 0,
      playerOptions: {
        // videojs and plugin options
        autoplay: true,
        width: window.innerWidth,
        height: window.innerHeight - 66,
        responsive: true,
        sources: [{
          type: 'application/x-mpegURL',
          src: this.link
        }],
        controlBar: {
          timeDivider: false,
          durationDisplay: false
        },
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } }
      }
    }
  },
  computed: {
    // verificar se está sendo utilizado
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  watch: {
    iptvVolume: function (val) {
      let volume = (val / 100)
      this.volume = volume
      this.player.volume(parseFloat(volume))
    },
    link: function (val) {
      this.playerOptions.sources[0].src = val
    }
    // intervaloMudo: function (val) {
    //   this.player.volume(0)
    //   setTimeout(() => {
    //     this.$emit('iptvVideo', true)
    //     this.player.volume(val)
    //   }, 14000)
    // }
  },
  mounted () {
    let volume = (this.iptvVolume / 100)
    this.volume = volume
    this.player.volume(parseFloat(volume))

    /* setTimeout(() => {
      this.playerOptions.sources[1].src = 'https://playplussdr-lh.akamaihd.net/i/pp_sdr@377858/master.m3u834'
      this.playerOptions.sources[0].src = 'application/x-mpegURL'
      this.playerOptions.autoplay = true
    }, 4000) */
  },
  methods: {

    teste () {
      console.log('-------')
    },
    playerReadied (player) {
      // this.player = player
      this.hls = player.tech({ IWillNotUseThisInPlugins: true }).hls
      player.tech_.hls.xhr.beforeRequest = function (options) {
        return options
      }
      player.volume(parseFloat(this.volume))
      // player.volume(volume)
    },
    onPlayng (player) {
      this.$emit('iptvVideo', true)
    },
    parou () {
      this.$emit('iptvVideo', false)
    },
    paused () {
      this.$emit('iptvPaused', false)
    },
    onResize () {
      console.log('#Onresize#', window.innerHeight)
      this.playerOptions.width = window.innerWidth
      this.playerOptions.height = window.innerHeight - 66
      // this.frame = { x: window.innerWidth, y: window.innerHeight }
    }
  }
}
</script>
